import { createI18n } from "vue-i18n";
import ro from "../locales/ro";
import en from "../locales/en";
export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("hello.locale") === "en" ? "en" : "ro",
  fallbackLocale: "ro",
  messages: { ro, en },
});
